// assets/pamela-addon-config.js
window.PAMELA_ADDON_CONFIG = {
  currencySymbol: "$",

  handles: {
    back: "lettering-on-back",
    back_word: "back-engraving-additional-word",
    vase: "vase-engraving",
    porcelain: "porcelain-portrait-installed",
    panel: "back-engraved-panel",
    panel_upgrade: "",
    clipart: "back-decorative-art",
    laser_spot: "laser-etching-spot",
    laser_scene: "laser-etching-scene",
    laser_portrait: "laser-etching-portrait",
    image_enhancement: "photo-editing-service"
  },

  skuRoles: {
    back_single: "ADDON_BACK_SINGLE",
    back_companion: "ADDON_BACK_COMPANION",
    back_word: "ADDON_BACK_WORD",
    vase_front: "ADDON_VASE_FRONT",
    vase_back: "ADDON_VASE_BACK",
    laser_spot_library_min: "ADDON_LASER_SPOT_LIBRARY_MIN",
    laser_spot_custom_min: "ADDON_LASER_SPOT_CUSTOM_MIN",
    laser_spot_extra_area: "ADDON_LASER_SPOT_EXTRA_AREA",
    laser_scene_library_min: "ADDON_LASER_SCENE_LIBRARY_MIN",
    laser_scene_custom_min: "ADDON_LASER_SCENE_CUSTOM_MIN",
    laser_scene_extra_area: "ADDON_LASER_SCENE_EXTRA_AREA",
    laser_portrait_min: "ADDON_LASER_PORTRAIT_MIN",
    laser_portrait_extra_area: "ADDON_LASER_PORTRAIT_EXTRA_AREA",
    laser_additional_face: "ADDON_LASER_ADDITIONAL_FACE",
    image_enhancement: "ADDON_IMAGE_ENHANCEMENT"
  },

  includedWords: { single: 10, companion: 20 },

  laserEtching: {
    spotMaxWidth: 11,
    spotMaxHeight: 14,
    portraitMaxWidth: 11,
    portraitMaxHeight: 14,
    // "Full Scene" base size included in the scene minimum price before the
    // per-square-inch rate kicks in (matches the "up to 14in tall" baseline
    // in the scene price sheet -- adjust width/height here, not the rate, if
    // the base size itself needs to change).
    sceneBaseWidthIn: 24,
    sceneBaseHeightIn: 14,
    rates: {
      spot: 2.25,
      scene: 0.8,
      sceneCustom: 2.5,
      portrait: 2.5
    },
    minimums: {
      spotLibrary: 190,
      spotCustom: 240,
      sceneLibrary: 350,
      sceneCustom: 500,
      portrait: 285
    },
    prepFees: {
      spotCustom: 50,
      sceneCustom: 200
    },
    additionalFaceFee: 75
  },

  // Optional: if you want to cap inscription size (recommended)
  maxBackChars: 600
};
